import { __rest } from "tslib";
import React from 'react';
import { Modal } from './Modal';
import { Button } from '@scp/ui-shared/components/buttons';
var TEXT = {
  DEFAULT_ACCEPT_LABEL: 'Continue',
  DEFAULT_CANCEL_LABEL: 'Cancel'
};
/**
 * @example ./__docs__/ConfirmationModal.md
 */

export function ConfirmationModal(_a) {
  var onCancel = _a.onCancel,
      onAccept = _a.onAccept,
      _a$acceptLabel = _a.acceptLabel,
      acceptLabel = _a$acceptLabel === void 0 ? TEXT.DEFAULT_ACCEPT_LABEL : _a$acceptLabel,
      _a$cancelLabel = _a.cancelLabel,
      cancelLabel = _a$cancelLabel === void 0 ? TEXT.DEFAULT_CANCEL_LABEL : _a$cancelLabel,
      _a$narrow = _a.narrow,
      narrow = _a$narrow === void 0 ? true : _a$narrow,
      isAcceptButtonLoading = _a.isAcceptButtonLoading,
      modalProps = __rest(_a, ["onCancel", "onAccept", "acceptLabel", "cancelLabel", "narrow", "isAcceptButtonLoading"]);

  return React.createElement(Modal, Object.assign({}, modalProps, {
    narrow: narrow,
    onRequestClose: onCancel,
    actions: React.createElement(React.Fragment, null, React.createElement(Button, {
      secondary: true,
      onClick: onCancel
    }, cancelLabel), React.createElement(Button, {
      onClick: onAccept,
      isLoading: isAcceptButtonLoading
    }, acceptLabel))
  }));
}